import axios, {
    AxiosResponse
} from 'axios';
import {
    OperationalControlsDto,
    WrappedResponse,
    UpdateOperationalControlsDto
} from './models'
export default class OperationalControlsApiService {
    public static get(clientConfig ? : {
        ignoreError ? : boolean
    }): Promise < AxiosResponse < WrappedResponse < OperationalControlsDto >>> {
        return axios.request( < any > {
            url: `/api/OperationalControls`,
            method: 'get',
            clientConfig: clientConfig
        })
    }
    public static update(body: UpdateOperationalControlsDto, clientConfig ? : {
        ignoreError ? : boolean
    }): Promise < AxiosResponse < WrappedResponse < OperationalControlsDto >>> {
        return axios.request( < any > {
            url: `/api/OperationalControls`,
            method: 'put',
            data: body,
            clientConfig: clientConfig
        })
    }
}